import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { HashRouter as Router, Route } from 'react-router-dom';
import axios from 'axios';
import * as R from 'ramda';

import { App } from 'containers';

import './styles/global.pcss';
import configureStore from './store';

const store = configureStore();

axios.interceptors.response.use(null, (error) => {
  if (error.response.status === 401) {
    const loginUrl = R.path(['application', 'settings', 'loginUrl'], store.getState());
    window.location.href = loginUrl || '/login/';
  }

  if (error.response.status === 452 && window.ROLE_MODEL_ACTIVE) {
    try {
      window.beeline.pages.restrictedActionHandler(error.response.data);
    } catch(err) {} // eslint-disable-line
  }

  return Promise.reject(error);
});

window.renderProfile = () => {
  createRoot(document.getElementById('root')).render(
    <Provider store={store}>
      <Router>
        <Route component={App} />
      </Router>
    </Provider>,
  );
};
